/* shto-doctors: tap a card's thumbnail to play its video in place, with sound and the browser's controls. Nothing
   downloads before the tap; starting one video pauses any other video on the page. A drag of the swipe row is not a tap
   (assets/shto-swipe.js swallows the click that ends a drag). The progress bar under the row on phones follows the
   card the row rests on. */
(function () {
  if (window.ShtoDoctors) return;
  window.ShtoDoctors = true;

  function pauseOthers(except) {
    document.querySelectorAll('.shto video').forEach(function (v) { if (v !== except && !v.paused) v.pause(); });
  }

  document.addEventListener('click', function (e) {
    var start = e.target.closest && e.target.closest('.shto-doctors__start');
    if (!start) return;
    var box = start.closest('.shto-doctors__media');
    var src = box && box.getAttribute('data-shto-video');
    if (!src) return;
    e.preventDefault();
    var video = box.querySelector('video');
    if (!video) {
      video = document.createElement('video');
      video.src = src;
      video.controls = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.preload = 'auto';
      var poster = box.querySelector('.shto-doctors__poster');
      if (poster) video.poster = poster.currentSrc || poster.src;
      video.setAttribute('aria-label', (start.getAttribute('aria-label') || 'Video').replace(/^Play the /, ''));
      video.addEventListener('play', function () { pauseOthers(video); });
      box.appendChild(video);
    }
    box.setAttribute('data-shto-playing', '');
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
    video.focus({ preventScroll: true });
  });

  // Progress bar: the segment of the card nearest the row's resting point is lit.
  function initProgress(root) {
    var row = root.querySelector('.shto-doctors__cards');
    var segs = root.querySelectorAll('.shto-doctors__segment');
    if (!row || !segs.length || row.shtoProgress) return;
    row.shtoProgress = true;
    var ticking = false;
    function update() {
      ticking = false;
      var cards = Array.prototype.filter.call(row.children, function (c) { return c.offsetWidth > 0; });
      if (!cards.length) return;
      var max = row.scrollWidth - row.clientWidth, here = row.scrollLeft, base = cards[0].offsetLeft, best = 0, dist = Infinity;
      cards.forEach(function (c, i) {
        var stop = Math.min(max, Math.max(0, c.offsetLeft - base));
        if (Math.abs(stop - here) < dist - 0.5) { dist = Math.abs(stop - here); best = i; }
      });
      if (max > 0 && here >= max - 1) best = cards.length - 1;
      segs.forEach(function (s, i) { s.toggleAttribute('data-shto-on', i === best); });
    }
    row.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll(scope) { (scope || document).querySelectorAll('.shto-doctors').forEach(initProgress); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
